<template>
  <div>
    <h3 v-if="question.label" class="field-label">{{ question.label }}</h3>
    <RichContent
      class="reset-liststyle text-base md:text-lg color-light-black"
      :content="value.value"
    />
  </div>
</template>

<script>
import RichContent from '@/components/RichContent'

export default {
  components: { RichContent },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    question: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
